import { render, staticRenderFns } from "./CustomerStat.vue?vue&type=template&id=0434ab8c&scoped=true&"
import script from "./CustomerStat.vue?vue&type=script&lang=js&"
export * from "./CustomerStat.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStat.vue?vue&type=style&index=0&id=0434ab8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0434ab8c",
  null
  
)

export default component.exports